module.exports = __webpack_public_path__ + "static/media/Apple-Macbook-Space-Grey.0fca5b96.png";